/* v2 cart workstream runtime (cart page + drawer). Plain deferred script, no dependencies.
   Everything is delegated from document and bound once, so section re-renders (morph) and
   theme-editor reloads never stack listeners. */
(function () {
  if (window.__xzcCart) return;
  window.__xzcCart = true;

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  /* Items the shopper can see: hidden engraving-fee lines are excluded (snippets/xz-v2-cart-count.liquid). */
  var FEE_IDS = [43781283217459, 43781283250227];
  function visibleCount(cart) {
    return ((cart && cart.items) || []).reduce(function (n, item) {
      return FEE_IDS.indexOf(item.variant_id) === -1 ? n + item.quantity : n;
    }, 0);
  }

  /* Content-Type only, no Accept header: the native product form's shape (assets/product-form.js) */
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  /* One add in the product form's request shape: top-level string id, quantity 1, properties (even
     empty), plus the cart sections. With a numeric id, items[], no properties and Accept:
     application/json, app web pixel 1735589939 threw on Shopify's product_added_to_cart event
     (see the landing grid and PLP card adds, assets/xz-v2-ws-landing.js and xz-v2-collection.js). */
  function addOne(variantId, properties) {
    var body = { id: String(variantId), quantity: 1, properties: properties || {} };
    var ids = sectionIds();
    if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
    return post('/cart/add.js', body);
  }

  /* The visible count (fee lines excluded) from a returned cart section; /cart.js only when no section carries it. */
  function countAfterAdd(sections) {
    var count;
    Object.keys(sections || {}).some(function (key) {
      var html = sections[key];
      var el = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[ref="cartItemCount"]');
      if (el) { count = parseInt(el.textContent, 10) || 0; return true; }
      return false;
    });
    if (count !== undefined) return Promise.resolve({ itemCount: count, cart: {} });
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return { itemCount: visibleCount(cart), cart: cart }; });
  }

  var pendingFocus = null;

  /* ---------- "Complete your set" ADD ---------- */
  function setLabel(button, text) {
    var label = button.querySelector('.xzc-btn__txt');
    if (label) label.textContent = text;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-xzc-add]');
    if (!button || button.classList.contains('is-busy')) return;
    event.preventDefault();
    var id = parseInt(button.getAttribute('data-xzc-add'), 10);
    if (!id) return;
    button.classList.add('is-busy');
    button.setAttribute('aria-busy', 'true');
    setLabel(button, 'Adding');
    /* The morph replaces the pressed button: land focus on the new line afterwards */
    var inDrawer = !!button.closest('.xzc-drawer');
    pendingFocus = { drawer: inDrawer, variantId: id, at: Date.now() };
    addOne(id, {})
      .then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () { return {}; }).then(function (detail) {
            var reason = String(detail.description || detail.message || '');
            throw new Error(/stock|available|sold/i.test(reason) ? 'Sold out' : 'Try again');
          });
        }
        setLabel(button, 'Added');
        button.setAttribute('data-state', 'added');
        return response.json().catch(function () { return {}; }).then(function (data) {
          var sections = (data && data.sections) || {};
          return countAfterAdd(sections).then(function (after) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: after.cart, sourceId: 'xzc-upsell', data: { itemCount: after.itemCount, sections: sections, source: 'xzc-upsell' } }
            }));
          });
        });
      })
      .catch(function (error) {
        if (pendingFocus && pendingFocus.variantId === id) pendingFocus = null;
        setLabel(button, error && error.message === 'Sold out' ? 'Sold out' : 'Try again');
        window.setTimeout(function () {
          if (!button.isConnected) return;
          setLabel(button, 'Add');
          button.classList.remove('is-busy');
          button.removeAttribute('aria-busy');
        }, 2500);
      });
  });


  /* ---------- Quick-add panel (sections/xz-v2-quick-add.liquid) ---------- */
  /* The control that opened quick add (PLP card cart icon, PDP upsell ADD), taken on its click,
     before assets/quick-add.js opens the dialog. */
  var qaOpener = null;
  document.addEventListener('click', function (event) {
    var host = event.target.closest && event.target.closest('quick-add-component');
    if (host) qaOpener = event.target.closest('a, button') || host;
  }, true);

  /* After a quick-add ADD the cart drawer opens while the quick-add dialog closes, so the drawer's
     own focus return lands on a control in a closed dialog (BODY). Same pattern as the PLP card add
     (focusCartDrawer in assets/xz-v2-collection.js): keep focus inside the open drawer, and when it
     closes, return focus to the control that opened quick add. */
  function focusDrawerThenReturn(returnTarget) {
    var tries = 0;
    var watched = null;
    var attempt = function () {
      var dialog = document.querySelector('cart-drawer-component dialog[open]');
      if (dialog && watched !== dialog) {
        watched = dialog;
        dialog.addEventListener('close', function () {
          tries = 25;
          window.setTimeout(function () { if (returnTarget && returnTarget.isConnected) returnTarget.focus(); }, 0);
        }, { once: true });
      }
      if (tries >= 25) return;
      if (dialog && !dialog.contains(document.activeElement)) {
        var target = dialog.querySelector('[autofocus], button[aria-label], a[href], button:not([disabled])');
        if (target) { target.focus(); return; }
      }
      if (++tries < 25) window.setTimeout(attempt, 100);
    };
    window.setTimeout(attempt, 50);
  }

  function qaVariants(root) {
    try { return JSON.parse(root.querySelector('[data-xzc-qa-variants]').textContent); } catch (e) { return []; }
  }
  function qaSync(root) {
    var variants = qaVariants(root);
    if (!variants.length) return null;
    var picked = [];
    root.querySelectorAll('[data-xzc-qa-option]:checked').forEach(function (input) {
      picked[Number(input.getAttribute('data-xzc-qa-option'))] = input.value;
    });
    var variant = variants.filter(function (v) {
      return picked.every(function (value, index) { return value === undefined || v.options[index] === value; });
    })[0] || null;
    root.querySelectorAll('[data-xzc-qa-chosen]').forEach(function (el) {
      var i = Number(el.getAttribute('data-xzc-qa-chosen'));
      if (picked[i] !== undefined) el.textContent = picked[i];
    });
    var idInput = root.querySelector('[data-xzc-qa-id]');
    var submit = root.querySelector('[data-xzc-qa-submit]');
    var label = root.querySelector('[data-xzc-qa-label]');
    var status = root.querySelector('[data-xzc-qa-status]');
    var price = root.querySelector('[data-xzc-qa-price]');
    var state = variant ? variant.state : 'unavailable';
    if (idInput && variant) idInput.value = variant.id;
    /* Variant image (e.g. Blue / Green whetstone); product cut-out when the variant has none */
    var img = root.querySelector('.xzc-qa__img');
    if (img && variant && variant.img && img.getAttribute('src') !== variant.img) {
      if (variant.srcset) img.setAttribute('srcset', variant.srcset); else img.removeAttribute('srcset');
      img.setAttribute('src', variant.img);
    }
    if (img && variant && variant.img) img.classList.toggle('xzc-qa__img--photo', !!variant.photo);
    if (price && variant) {
      /* The struck price keeps its visually hidden "Regular price" (screen readers do not announce strikethrough). */
      price.innerHTML = '<span class="xzc-qa__now"></span>' + (variant.compare ? '<s class="xzc-qa__was"><span class="visually-hidden">Regular price </span></s>' : '');
      price.querySelector('.xzc-qa__now').textContent = variant.price;
      if (variant.compare) price.querySelector('.xzc-qa__was').appendChild(document.createTextNode(variant.compare));
    }
    var buyable = state === 'buyable' || state === 'preorder';
    if (submit) submit.disabled = !buyable;
    if (label) label.textContent = state === 'preorder' ? 'Pre-order' : buyable ? 'Add to cart' : state === 'soldout' ? 'Sold out' : 'Unavailable';
    if (status) {
      status.textContent = state === 'preorder' ? variant.preorder : state === 'soldout' ? 'This option is sold out.' : '';
      status.setAttribute('data-tone', state === 'preorder' ? 'soft' : state === 'buyable' ? '' : 'accent');
    }
    /* Option chips: a value with no buyable variant for the other current selections is struck
       through, as on the PDP picker (still selectable, and named "sold out" for screen readers). */
    root.querySelectorAll('[data-xzc-qa-option]').forEach(function (input) {
      var index = Number(input.getAttribute('data-xzc-qa-option'));
      var available = variants.some(function (v) {
        if (v.options[index] !== input.value || !(v.state === 'buyable' || v.state === 'preorder')) return false;
        return picked.every(function (value, i) { return i === index || value === undefined || v.options[i] === value; });
      });
      var chip = input.closest('.xzc-qa__value');
      if (chip) chip.classList.toggle('is-unavailable', !available);
      if (available) input.removeAttribute('aria-label'); else input.setAttribute('aria-label', input.value + ', sold out');
    });
    /* A sold-out variant: NOTIFY ME (to the PDP on that variant, where the back-in-stock form lives)
       instead of a dead SOLD OUT button, as the PDP and the PLP cards offer. */
    var notify = root.querySelector('[data-xzc-qa-notify]');
    var showNotify = !!(notify && variant && state === 'soldout');
    if (notify) {
      notify.hidden = !showNotify;
      if (showNotify) {
        var url = new URL(root.getAttribute('data-product-url') || notify.getAttribute('href'), window.location.origin);
        url.searchParams.set('variant', variant.id);
        notify.setAttribute('href', url.pathname + url.search);
      }
    }
    if (submit) submit.hidden = showNotify;
    return variant;
  }
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('[data-xzc-qa-option]')) return;
    var root = input.closest('[data-xzc-quick-add]');
    if (root) qaSync(root);
  });
  function qaWatch() {
    var host = document.getElementById('quick-add-modal-content');
    if (!host || host.__xzcWatch) return;
    host.__xzcWatch = true;
    new MutationObserver(function () {
      var root = host.querySelector('[data-xzc-quick-add]');
      if (root && !root.__xzcSynced) { root.__xzcSynced = true; qaSync(root); }
    }).observe(host, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', qaWatch); else qaWatch();
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-xzc-qa-form]')) return;
    event.preventDefault();
    var root = form.closest('[data-xzc-quick-add]');
    var variant = qaSync(root);
    var submit = form.querySelector('[data-xzc-qa-submit]');
    var label = form.querySelector('[data-xzc-qa-label]');
    var status = form.querySelector('[data-xzc-qa-status]');
    if (!variant || !(variant.state === 'buyable' || variant.state === 'preorder') || submit.classList.contains('is-busy')) return;
    /* No "Knife Quantity": quick add never engraves, and an unengraved knife carries the same (empty) properties
       on every add path (PDP, sticky bar, cards, upsells), so the same knife merges into one cart line. */
    var properties = {};
    if (variant.state === 'preorder' && variant.preorder) properties['Pre-order'] = variant.preorder;
    submit.classList.add('is-busy');
    var original = label.textContent;
    label.textContent = 'Adding';
    addOne(variant.id, properties)
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(String(data.description || data.message || 'Could not add to cart'));
          var sections = data.sections || {};
          return countAfterAdd(sections).then(function (after) {
            label.textContent = 'Added';
            /* The drawer opens on this event and the quick-add dialog closes: send focus back to
               the card control that opened quick add once the drawer closes. */
            focusDrawerThenReturn(qaOpener);
            form.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: after.cart, sourceId: 'xzc-quick-add', data: { itemCount: after.itemCount, sections: sections, source: 'xzc-quick-add', variantId: String(variant.id) } }
            }));
          });
        });
      })
      .catch(function (error) {
        if (status) { status.textContent = error.message; status.setAttribute('data-tone', 'accent'); }
        label.textContent = original;
      })
      .then(function () { submit.classList.remove('is-busy'); });
  });

  /* ---------- Rails: arrows, drag, arrow state ---------- */
  function railTrack(rail) { return rail && rail.querySelector('[data-xzc-rail-track]'); }
  function railStep(track) {
    var card = track.firstElementChild;
    var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 24;
    return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
  }
  function syncArrows(rail) {
    var track = railTrack(rail);
    if (!track) return;
    var prev = rail.querySelector('[data-xzc-rail-prev]');
    var next = rail.querySelector('[data-xzc-rail-next]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
    /* Every card fits: no arrows, no grab cursor */
    var fits = track.scrollWidth <= track.clientWidth + 2;
    track.classList.toggle('is-static', fits);
    var arrows = rail.querySelector('.xzc-arrows');
    if (arrows) arrows.classList.toggle('is-static', fits);
  }
  function syncAll() { document.querySelectorAll('[data-xzc-rail]').forEach(syncArrows); }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest && event.target.closest('[data-xzc-rail-prev], [data-xzc-rail-next]');
    if (!arrow) return;
    var rail = arrow.closest('[data-xzc-rail]');
    var track = railTrack(rail);
    if (!track) return;
    var dir = arrow.hasAttribute('data-xzc-rail-next') ? 1 : -1;
    /* Reduced motion: jump, as every other v2 rail does (xz-v2-ws-pdp.js, xz-v2-ws-landing.js). */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: dir * railStep(track), behavior: reduce ? 'auto' : 'smooth' });
  });

  document.addEventListener('scroll', function (event) {
    var target = event.target;
    if (target && target.matches && target.matches('[data-xzc-rail-track]')) {
      window.requestAnimationFrame(function () { syncArrows(target.closest('[data-xzc-rail]')); });
    }
  }, true);

  var drag = null;
  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    var track = event.target.closest && event.target.closest('.xzc-upsell--page [data-xzc-rail-track]');
    if (!track || event.target.closest('button')) return;
    drag = { track: track, x: event.clientX, left: track.scrollLeft, moved: false };
  });
  document.addEventListener('pointermove', function (event) {
    if (!drag) return;
    var dx = event.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 3) { drag.moved = true; drag.track.classList.add('is-dragging'); }
    if (drag.moved) { drag.track.scrollLeft = drag.left - dx; event.preventDefault(); }
  });
  function endDrag() {
    if (!drag) return;
    var track = drag.track;
    var moved = drag.moved;
    drag = null;
    track.classList.remove('is-dragging');
    if (moved) {
      var swallow = function (e) { e.preventDefault(); e.stopPropagation(); };
      track.addEventListener('click', swallow, { capture: true, once: true });
      window.setTimeout(function () { track.removeEventListener('click', swallow, true); }, 0);
    }
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
  document.addEventListener('dragstart', function (event) {
    if (event.target.closest && event.target.closest('.xzc-upsell--page [data-xzc-rail-track]')) event.preventDefault();
  });

  /* ---------- Keep focus in place after REMOVE (the removed row takes focus with it) ---------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.xzc-line .xzc-textbtn');
    if (!button || !/onLineItemRemove/.test(button.getAttribute('on:click') || '')) return;
    var host = button.closest('cart-items-component');
    var lines = host ? Array.prototype.slice.call(host.querySelectorAll('.xzc-line')) : [];
    pendingFocus = { sectionId: host && host.dataset.sectionId, drawer: !!button.closest('.xzc-drawer'), index: Math.max(0, lines.indexOf(button.closest('.xzc-line'))), at: Date.now() };
  }, true);
  /* Engraving confirm (assets/cart-engraving.js): the morph replaces the line and its ADD ENGRAVING button */
  document.addEventListener('xzc:focus-line', function (event) {
    var detail = event.detail || {};
    if (!detail.variantId) return;
    pendingFocus = { drawer: !!detail.drawer, variantId: String(detail.variantId), source: detail.source || null, engraved: true, at: Date.now() };
  });
  function restoreFocus() {
    var pending = pendingFocus;
    if (!pending) return;
    /* Wait for the morph to replace the control that opened the flow (engraving refresh is async) */
    if (pending.source && pending.source.isConnected && Date.now() - pending.at < 6000) {
      window.setTimeout(restoreFocus, 100);
      return;
    }
    pendingFocus = null;
    if (Date.now() - pending.at > 10000) return;
    var active = document.activeElement;
    if (active && active !== document.body && active.isConnected) return;
    var root = pending.drawer ? document.querySelector('dialog.xzc-drawer[open]') : document.querySelector('.xzc-page');
    if (!root) return;
    var lines = root.querySelectorAll('.xzc-line');
    var target = null;
    if (pending.variantId) {
      var added = root.querySelector('.xzc-line[data-key^="' + pending.variantId + ':"]' + (pending.engraved ? '[data-engraved]' : '') + ' .xzc-line__name') ||
        root.querySelector('.xzc-line[data-key^="' + pending.variantId + ':"] .xzc-line__name');
      target = added || root.querySelector(pending.drawer ? '.xzc-close' : '.xzc-line__name');
    } else if (lines.length) {
      var line = lines[Math.min(pending.index, lines.length - 1)];
      target = line.querySelector('.xzc-line__links .xzc-textbtn:last-child') || line.querySelector('.xzc-line__name');
    } else {
      target = root.querySelector(pending.drawer ? '.xzc-close' : '.xzc-typecell__link');
    }
    if (target) target.focus();
  }

  /* ---------- Space on buttons inside cart overlays ----------
     @theme/dialog's scroll lock prevents the default of every Space keydown outside text fields
     and scroll regions, which also cancels a button's native Space activation. Restore it for the
     cart overlays only when that happened (so nothing double-fires once dialog.js exempts buttons). */
  var OVERLAYS = 'dialog.xzc-drawer[open], dialog.xzc-modal[open]';
  var spaceTarget = null;
  function spaceActivatable(el) {
    if (!el || !el.closest || !el.closest(OVERLAYS)) return false;
    if (el.disabled) return false;
    var tag = el.tagName;
    if (tag === 'BUTTON' || tag === 'SUMMARY' || el.getAttribute('role') === 'button') return true;
    return tag === 'INPUT' && (el.type === 'checkbox' || el.type === 'radio');
  }
  window.addEventListener('keydown', function (event) {
    if (event.key !== ' ' && event.key !== 'Spacebar') return;
    var el = document.activeElement;
    spaceTarget = event.defaultPrevented && !event.repeat && spaceActivatable(el) ? el : (event.repeat ? spaceTarget : null);
  });
  window.addEventListener('keyup', function (event) {
    if (event.key !== ' ' && event.key !== 'Spacebar') return;
    var el = spaceTarget;
    spaceTarget = null;
    if (el && el === document.activeElement && el.isConnected) el.click();
  });

  /* ---------- Cart page: fixed bottom CHECKOUT bar on <=991 while the summary CTA is below the fold ---------- */
  var barObserver = null;
  function bindBar() {
    var html = document.documentElement;
    if (barObserver) { barObserver.disconnect(); barObserver = null; }
    html.classList.remove('xzc-bar-on');
    var bar = document.querySelector('[data-xzc-bar]');
    var cta = document.querySelector('.xzc-page .xzc-summary .xzc-ctas');
    if (!bar || !cta || !('IntersectionObserver' in window)) return;
    barObserver = new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      var below = !entry.isIntersecting && entry.boundingClientRect.top > 0;
      bar.classList.toggle('is-visible', below);
      html.classList.toggle('xzc-bar-on', below);
      bar.setAttribute('aria-hidden', below ? 'false' : 'true');
      bar.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = below ? 0 : -1; });
    });
    barObserver.observe(cta);
  }

  document.addEventListener('cart:update', function () {
    window.setTimeout(syncAll, 60);
    window.setTimeout(function () { restoreFocus(); bindBar(); }, 120);
  });
  document.addEventListener('dialog:open', function () { window.setTimeout(syncAll, 60); }, true);
  window.addEventListener('resize', function () { window.requestAnimationFrame(syncAll); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncAll(); bindBar(); });
  else { syncAll(); bindBar(); }
  document.addEventListener('shopify:section:load', function () { syncAll(); bindBar(); });
})();
